import React, { useState, useEffect } from 'react';
import './ComingSoonPage.css';

// CountdownUnit Component
const CountdownUnit = ({ value, label }) => {
  // Ensure value is always a 2-character string
  const padded = value.toString().padStart(2, '0');
  const digits = [padded[0], padded[1]];
  return (
    <div className="countdown-unit">
      <div className="digits-container">
        <div className="digit-box">
          <span className="digit">{digits[0]}</span>
        </div>
        <div className="digit-box">
          <span className="digit">{digits[1]}</span>
        </div>
      </div>
      <div className="unit-label">{label}</div>
    </div>
  );
};

// CountdownTimer Component
const CountdownTimer = () => {
  const calculateTimeLeft = () => {
    const targetDate = new Date('2025-12-16T12:00:00');
    const now = new Date();
    const difference = targetDate - now;
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);
    return { days, hours, minutes, seconds };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const formatTime = (time) => {
    return time.toString().padStart(2, '0');
  };

  return (
    <div className="countdown-timer">
      <CountdownUnit 
        value={formatTime(timeLeft.days)} 
        label="DAYS" 
      />
      <CountdownUnit 
        value={formatTime(timeLeft.hours)} 
        label="HOURS" 
      />
      <CountdownUnit 
        value={formatTime(timeLeft.minutes)} 
        label="MINUTES" 
      />
    </div>
  );
};

// EmailSubscription Component
const EmailSubscription = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && email.includes('@')) {
      setIsSubmitted(true);
      
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <form className="email-subscription" onSubmit={handleSubmit}>
      <div className="input-container">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email Address"
          className="email-input"
          required
          aria-label="Email Address"
        />
        <button 
          type="submit" 
          className="notify-button"
          disabled={isSubmitted}
        >
          {isSubmitted ? 'Thank You!' : 'Notify Me'}
        </button>
      </div>
    </form>
  );
};

// SocialIcons Component with corrected positioning
const SocialIcons = () => {
  const socialLinks = [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/nirmal.labs',
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" fill="white"/>
          <path d="M15 2C8.375 2 3 7.375 3 14C3 20.125 7.5 25.25 13.375 26V17.875H10.75V14H13.375V11.125C13.375 8.5 15.125 6.875 17.5 6.875C18.625 6.875 19.75 7.125 19.75 7.125V9.625H18.5C17.25 9.625 16.875 10.375 16.875 11.125V14H19.625L19.125 17.875H16.875V26C22.75 25.25 27 20.125 27 14C27 7.375 21.625 2 15 2Z" fill="#1877F2"/>
        </svg>
      )
    },
    {
      name: 'X',
      href: 'https://x.com/LabsNirmal',
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" fill="white"/>
          <path d="M24.375 9.375C23.5547 9.72656 22.6875 9.96094 21.7969 10.0781C22.7109 9.51562 23.4141 8.625 23.7422 7.57812C22.875 8.10938 21.9141 8.48438 20.9062 8.67188C20.0625 7.78125 18.8672 7.25 17.5781 7.25C15.0938 7.25 13.0781 9.26562 13.0781 11.75C13.0781 12.0938 13.1172 12.4297 13.1875 12.75C9.51562 12.5781 6.25781 10.7812 4.04688 8.07812C3.67188 8.72656 3.46094 9.51562 3.46094 10.3594C3.46094 11.9297 4.25781 13.3125 5.48438 14.1328C4.75781 14.1094 4.07812 13.9219 3.48438 13.6094V13.6719C3.48438 15.8594 5.03906 17.6719 7.125 18.0703C6.76562 18.1719 6.375 18.2266 5.97656 18.2266C5.69531 18.2266 5.42188 18.1953 5.15625 18.1406C5.71094 19.9219 7.375 21.2266 9.32812 21.2656C7.78125 22.4766 5.84375 23.1875 3.75 23.1875C3.39844 23.1875 3.05469 23.1641 2.71875 23.1172C4.69531 24.4141 7.05469 25.1562 9.58594 25.1562C17.5703 25.1562 21.9375 18.2969 21.9375 12.2656C21.9375 12.0781 21.9375 11.8906 21.9297 11.7031C22.8047 11.0625 23.5547 10.2656 24.1406 9.35938L24.375 9.375Z" fill="#1DA1F2"/>
        </svg>
      )
    },
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/nirmallabsvns/',
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" fill="white"/>
          <path d="M25.5 3H4.5C3.675 3 3 3.675 3 4.5V25.5C3 26.325 3.675 27 4.5 27H25.5C26.325 27 27 26.325 27 25.5V4.5C27 3.675 26.325 3 25.5 3ZM10.5 22.5H7.5V12H10.5V22.5ZM9 10.875C8.175 10.875 7.5 10.2 7.5 9.375C7.5 8.55 8.175 7.875 9 7.875C9.825 7.875 10.5 8.55 10.5 9.375C10.5 10.2 9.825 10.875 9 10.875ZM22.5 22.5H19.5V17.4C19.5 16.2 19.05 15.6 18.075 15.6C17.025 15.6 16.5 16.275 16.5 17.4V22.5H13.5V12H16.5V13.35C16.875 12.675 17.775 12 19.125 12C21.075 12 22.5 13.2 22.5 16.05V22.5Z" fill="#0077B5"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/nirmallabs/',
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" fill="white"/>
          <defs>
            <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#833AB4"/>
              <stop offset="50%" stopColor="#FD1D1D"/>
              <stop offset="100%" stopColor="#FCB045"/>
            </linearGradient>
          </defs>
          <path d="M15 10.3125C12.4219 10.3125 10.3125 12.4219 10.3125 15C10.3125 17.5781 12.4219 19.6875 15 19.6875C17.5781 19.6875 19.6875 17.5781 19.6875 15C19.6875 12.4219 17.5781 10.3125 15 10.3125ZM15 17.8125C13.4531 17.8125 12.1875 16.5469 12.1875 15C12.1875 13.4531 13.4531 12.1875 15 12.1875C16.5469 12.1875 17.8125 13.4531 17.8125 15C17.8125 16.5469 16.5469 17.8125 15 17.8125ZM20.9375 10.125C20.9375 10.6641 20.5039 11.0977 19.9648 11.0977C19.4258 11.0977 18.9922 10.6641 18.9922 10.125C18.9922 9.58594 19.4258 9.15234 19.9648 9.15234C20.5039 9.15234 20.9375 9.58594 20.9375 10.125Z" fill="url(#instagram-gradient)"/>
        </svg>
      )
    },
    {
      name: 'Dribbble',
      href: 'https://dribbble.com',
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="30" height="30" fill="white"/>
          <path d="M15 6.5625C10.2188 6.5625 6.5625 10.2188 6.5625 15C6.5625 19.7812 10.2188 23.4375 15 23.4375C19.7812 23.4375 23.4375 19.7812 23.4375 15C23.4375 10.2188 19.7812 6.5625 15 6.5625ZM21.6797 11.7656C22.5469 12.9609 23.0391 14.4141 23.0391 15.9375C22.8047 15.8906 20.1328 15.3516 17.4375 15.6797C17.3672 15.5156 17.3203 15.3281 17.25 15.1641C17.0859 14.7578 16.8984 14.3516 16.7109 13.9688C19.7344 12.6797 21.5391 11.9297 21.6797 11.7656ZM15 8.95312C16.7109 8.95312 18.2812 9.5625 19.5234 10.5703C19.4062 10.7109 17.7891 11.3906 14.9531 12.5391C13.8047 10.4531 12.5391 8.76562 12.3516 8.50781C13.1484 8.67188 14.0625 8.95312 15 8.95312Z" fill="#EA4C89"/>
        </svg>
      )
    }
  ];

  return (
    <div className="social-icons-container">
      <div className="social-icons">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            aria-label={`Follow us on ${link.name}`}
          >
            {link.icon}
          </a>
        ))}
      </div>
    </div>
  );
};

// BackgroundElements Component
const BackgroundElements = () => {
  return (
    <div className="background-elements">
      <div className="gradient-ellipse ellipse-left"></div>
      <div className="gradient-ellipse ellipse-right"></div>
    </div>
  );
};

// Main ComingSoonPage Component
const ComingSoonPage = () => {
  return (
    <main className="coming-soon-page">
      <BackgroundElements />
      
      <div className="content-container">
        <div className="main-content">
          <h1 className="main-title">Launching Soon</h1>
          
          <CountdownTimer />
          
          <p className="subtitle">We'll let you know when we are Launching</p>
          
          <EmailSubscription />
        </div>
        
        <SocialIcons />
      </div>
      
    </main>
  );
};

export default ComingSoonPage;
